import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  CustomModalModule,
  ComboModule,
} from 'beyond-util';

import { SpotoviComponent } from './spotovi.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    CustomModalModule,
    ComboModule,
    NgxSpinnerModule,
  ],
  declarations: [SpotoviComponent],
  entryComponents: [SpotoviComponent],
  exports: [SpotoviComponent],
})
export class SpotoviModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/spotovi/spotovi.module.ts